import { memo } from 'react';
import VK, { CommunityMessages } from 'react-vk';

const VKServices = memo(() => (
  <VK apiId={7491692} options={{ onlyWindgets: true }}>
    <CommunityMessages groupId={183713313} />
  </VK>
));

export default VKServices;
